export default defineNuxtPlugin((nuxtApp) => {
  const previousHandler = nuxtApp.vueApp.config.errorHandler
  const previousWarnHandler = nuxtApp.vueApp.config.warnHandler

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    const message = (err as Error)?.message ?? ''
    if (
      message.includes("Cannot read properties of null (reading '$el')") ||
      message.includes("Cannot read property '$el' of null")
    ) {
      return
    }
    previousHandler?.(err, instance, info)
  }

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    if (
      msg.includes('onMounted is called when there is no active component instance') ||
      msg.includes('Lifecycle injection APIs can only be used during execution of setup')
    ) {
      return
    }
    previousWarnHandler?.(msg, instance, trace)
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      const message = (event.reason as Error)?.message ?? ''
      if (
        message.includes("Cannot read properties of null (reading '$el')") ||
        message.includes("Cannot read property '$el' of null")
      ) {
        event.preventDefault()
      }
    })
  }
})
